// Pins this system offers in PinnedBar.
const pins = {
  pinnable: [
  { id: 'hp',       labelKey: 'pinned.hp' },
  { id: 'dh-armor', labelKey: 'pinned.dhArmor' },
  { id: 'dh-hope',  labelKey: 'pinned.dhHope' },
  { id: 'dh-fear',  labelKey: 'pinned.dhFear' },
  ],
};

export default pins;
